/**
 * 100 paylines for the 5×4 variant (row index 0 = top, 3 = bottom per reel).
 * Copied from Crown Crush `Lines100` / `crownCrush100` so we can talk to
 * `CrownCrush100` until our own backend title exists.
 */
export const PAYLINES_100 = [
  [1, 1, 1, 1, 1], //   1
  [2, 2, 2, 2, 2], //   2
  [0, 0, 0, 0, 0], //   3
  [3, 3, 3, 3, 3], //   4
  [2, 3, 3, 3, 2], //   5
  [1, 0, 0, 0, 1], //   6
  [0, 1, 1, 1, 0], //   7
  [3, 2, 2, 2, 3], //   8
  [2, 3, 2, 3, 2], //   9
  [1, 0, 1, 0, 1], //  10
  [0, 1, 0, 1, 0], //  11
  [3, 2, 3, 2, 3], //  12
  [1, 3, 1, 3, 1], //  13
  [2, 0, 2, 0, 2], //  14
  [0, 2, 0, 2, 0], //  15
  [3, 1, 3, 1, 3], //  16
  [0, 0, 1, 0, 0], //  17
  [3, 3, 2, 3, 3], //  18
  [2, 2, 3, 2, 2], //  19
  [1, 1, 0, 1, 1], //  20
  [0, 3, 0, 3, 0], //  21
  [3, 0, 3, 0, 3], //  22
  [1, 2, 1, 2, 1], //  23
  [2, 1, 2, 1, 2], //  24
  [0, 1, 2, 2, 3], //  25
  [3, 2, 1, 1, 0], //  26
  [1, 3, 3, 3, 1], //  27
  [2, 0, 0, 0, 2], //  28
  [0, 2, 3, 1, 0], //  29
  [3, 1, 0, 2, 3], //  30
  [1, 3, 2, 0, 2], //  31
  [2, 0, 1, 3, 1], //  32
  [0, 1, 2, 1, 0], //  33
  [3, 2, 1, 2, 3], //  34
  [2, 3, 0, 3, 1], //  35
  [1, 0, 3, 0, 2], //  36
  [1, 2, 2, 3, 0], //  37
  [2, 1, 1, 0, 3], //  38
  [0, 0, 3, 1, 2], //  39
  [3, 3, 0, 2, 1], //  40
  [1, 1, 3, 0, 2], //  41
  [2, 2, 0, 3, 1], //  42
  [0, 0, 2, 1, 3], //  43
  [3, 3, 1, 2, 0], //  44
  [1, 2, 0, 1, 3], //  45
  [2, 1, 3, 2, 0], //  46
  [0, 3, 2, 3, 1], //  47
  [3, 0, 1, 0, 2], //  48
  [1, 1, 2, 3, 0], //  49
  [2, 2, 1, 0, 3], //  50
  [0, 3, 3, 2, 1], //  51
  [3, 0, 0, 1, 2], //  52
  [2, 3, 1, 2, 0], //  53
  [1, 0, 2, 1, 3], //  54
  [0, 2, 0, 3, 1], //  55
  [3, 1, 3, 0, 2], //  56
  [0, 0, 1, 2, 3], //  57
  [3, 3, 2, 1, 0], //  58
  [1, 2, 3, 0, 1], //  59
  [2, 1, 0, 3, 2], //  60
  [1, 1, 2, 0, 3], //  61
  [2, 2, 1, 3, 0], //  62
  [1, 1, 3, 2, 0], //  63
  [2, 2, 0, 1, 3], //  64
  [0, 1, 2, 3, 3], //  65
  [3, 2, 1, 0, 0], //  66
  [2, 3, 0, 1, 2], //  67
  [1, 0, 3, 2, 1], //  68
  [2, 3, 2, 1, 0], //  69
  [1, 0, 1, 2, 3], //  70
  [0, 0, 2, 3, 1], //  71
  [3, 3, 1, 0, 2], //  72
  [0, 1, 3, 2, 0], //  73
  [3, 2, 0, 1, 3], //  74
  [0, 2, 1, 3, 1], //  75
  [3, 1, 2, 0, 2], //  76
  [0, 2, 2, 3, 1], //  77
  [3, 1, 1, 0, 2], //  78
  [2, 3, 3, 1, 0], //  79
  [1, 0, 0, 2, 3], //  80
  [0, 2, 3, 3, 1], //  81
  [3, 1, 0, 0, 2], //  82
  [0, 3, 0, 2, 1], //  83
  [3, 0, 3, 1, 2], //  84
  [1, 3, 0, 2, 0], //  85
  [2, 0, 3, 1, 3], //  86
  [1, 3, 1, 0, 2], //  87
  [2, 0, 2, 3, 1], //  88
  [0, 3, 1, 2, 1], //  89
  [3, 0, 2, 1, 2], //  90
  [1, 2, 3, 3, 0], //  91
  [2, 1, 0, 0, 3], //  92
  [1, 2, 1, 0, 3], //  93
  [2, 1, 2, 3, 0], //  94
  [0, 3, 3, 1, 2], //  95
  [3, 0, 0, 2, 1], //  96
  [0, 3, 2, 1, 2], //  97
  [3, 0, 1, 2, 1], //  98
  [1, 2, 0, 0, 3], //  99
  [2, 1, 3, 3, 0], // 100
];
